import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        {/*<section className="colorlib-about" data-section="about">*/}
        {/*<div className="colorlib-narrow-content">*/}
        {/*    <div className="row">*/}
        {/*    <div className="col-md-12">*/}
        {/*        <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">*/}
        {/*        <div className="col-md-12">*/}
        {/*            <div className="about-desc">*/}
        {/*            <span className="heading-meta">About Us</span>*/}
        {/*            <h2 className="colorlib-heading">Who Am I?</h2>*/}
        {/*            <p>Im a Computer Science student from Northeastern University, graduating in May 2024.</p>*/}
        {/*                <p>I am experienced with developing websites and microservices. I also have experience in machine learning engineer.</p>*/}
        {/*                <p>I love taking on changeing and solving real-world problems while embracing new skills and technology. I am passionate and committed to social impact through equity in science and technology</p>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*    </div>*/}
        {/*</div>*/}
        {/*</section>*/}
        <section className="colorlib-about" data-section="skills">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">Here are some of my expertise</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Web Development </h3>
                    <p>I can build websites and dashboards using Typescript, React, HTML, CSS</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Microservice & Cloud</h3>
                    <p>Experienced in building microservices with REST APIs on AWS (Lambda, DynamoDB, SES, SQS) with NodeJS and Java Spring</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Deep Learning</h3>
                    <p>I build abstractive news summarizer with Google's BERT model on Pytorch</p>
                </div>
                </div>
            </div>
            {/*

            <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                <span className="icon">
                    <i className="icon-layers2" />
                </span>
                <div className="desc">
                    <h3>Graphic Design</h3>
                    <p>My friend knows .. P</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Digital Marketing</h3>
                    <p>I use Instagram eight hours a day :) </p>
                </div>
                </div>
            </div>
            */}
            </div>
        </div>
        </section>
      </div>
    )
  }
}
